import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Link } from "@tanstack/react-router"
import { GridList, GridListItem } from "react-aria-components"
import { useTranslation } from "react-i18next"

import { default as Vehicle } from "@/assets/illustrations/vehicle.svg"
import { LinkButton } from "@/globalComponents/atoms/Button"
import Icon from "@/globalComponents/atoms/Icon"
import Text from "@/globalComponents/atoms/Text"
import { cn } from "@/utilities/etc"
import { meQueryOptions } from "@/utilities/hooks/queries/user"

import styles from "../index.module.css"

export const Route = createFileRoute("/_authenticated/account/vehicles/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { data: me } = useSuspenseQuery(meQueryOptions())
  const navigate = Route.useNavigate()
  const search = Route.useSearch()
  const vehicles = me?.inflowUser.savedPlates
  const { t } = useTranslation()
  return (
    <>
      {!vehicles?.length ? (
        <div className="centered-content">
          <Vehicle />
          {/*<Text
            className="center medium"
            style={{ marginTop: "var(--space-5)", maxWidth: "20rem" }}
          >
            {t("account.vehicles.noVehiclesFound")}
          </Text>*/}
          <LinkButton
            hue="secondary"
            variant="default"
            to="/account/vehicles/create"
            search={search}
            style={{ marginTop: "var(--space-5)" }}
          >
            <Icon name="add" slot="left" />
            {t("account.vehicles.addFirstVehicle")}
          </LinkButton>
        </div>
      ) : (
        <>
          <LinkButton
            hue="secondary"
            variant="default"
            to="/account/vehicles/create"
            search={search}
          >
            <Icon name="add" slot="left" />
            {t("account.vehicles.addVehicle")}
          </LinkButton>
          <GridList
            items={vehicles}
            className={styles.linkList}
            selectionBehavior="replace"
            aria-label={t("account.vehicles")}
          >
            {(item) => (
              <GridListItem
                id={`${item.lastUsed}${item.nickname}${item.plate}`}
                key={`${item.lastUsed}${item.nickname}${item.plate}`}
                textValue={
                  item.nickname
                    ? `${item.nickname} - ${item.plate}`
                    : item.plate
                }
                onAction={() =>
                  navigate({
                    to: "/account/vehicles/edit",
                    search: { ...search, plate: item.plate },
                  })
                }
              >
                <Link
                  to="/account/vehicles/edit"
                  search={{ ...search, plate: item.plate }}
                  className={cn(styles.links, "bold")}
                >
                  <div className={styles.linkIcon}>
                    <Icon name="car" />
                  </div>
                  <div>
                    {item.nickname && (
                      <Text className="bold">{item.nickname}</Text>
                    )}
                    {item.nickname ? (
                      <Text level={2}>{item.plate}</Text>
                    ) : (
                      <Text className="bold">{item.plate}</Text>
                    )}
                  </div>
                  <Icon name="chevronRight" />
                </Link>
              </GridListItem>
            )}
          </GridList>
        </>
      )}
    </>
  )
}
